import request from '../utils/request';
import { downloadResponseAsFile } from '../utils/downloadFile';
const BASE_URL = '/api/v1/admin/sales-reps/';
const withQuery = (url, params) => {
    const queryString = params.toString();
    return queryString ? `${url}?${queryString}` : url;
};
export function fetchSalesReps(filters) {
    const params = new URLSearchParams();
    const search = filters?.search?.trim();
    if (search)
        params.append('search', search);
    if (filters?.is_active !== undefined)
        params.append('is_active', String(filters.is_active));
    return request().get(withQuery(BASE_URL, params)).send();
}
export function createSalesRep(payload) {
    return request().post(BASE_URL).send(payload);
}
export function updateSalesRep(id, payload) {
    return request().patch(`${BASE_URL}${id}/`).send(payload);
}
export function fetchSalesSummary(filters) {
    const params = new URLSearchParams();
    if (filters?.groupBy)
        params.append('group_by', filters.groupBy);
    if (filters?.dateFrom)
        params.append('date_from', filters.dateFrom);
    if (filters?.dateTo)
        params.append('date_to', filters.dateTo);
    return request().get(withQuery(`${BASE_URL}sales-summary/`, params)).send();
}
const DEFAULT_REPORT_ERROR = 'Failed to download sales report';
/** Best-effort readable message from a DRF error body ({detail} or {field: [messages]}). */
const readErrorMessage = async (response) => {
    try {
        const body = await response.json();
        if (typeof body?.detail === 'string')
            return body.detail;
        const first = Object.values(body ?? {}).find((value) => Array.isArray(value) && typeof value[0] === 'string');
        return first?.[0] ?? DEFAULT_REPORT_ERROR;
    }
    catch {
        return DEFAULT_REPORT_ERROR;
    }
};
/**
 * Downloads the Sales Summary export as an .xlsx file. Uses a same-origin fetch (the Django
 * session cookie authenticates it) because the request wrapper is JSON-only.
 */
export async function downloadSalesReport(options = {}) {
    const params = new URLSearchParams();
    if (options.dateFrom)
        params.append('date_from', options.dateFrom);
    if (options.dateTo)
        params.append('date_to', options.dateTo);
    const path = options.salesRepId ? `${BASE_URL}${options.salesRepId}/sales-report/` : `${BASE_URL}sales-report/`;
    const response = await fetch(withQuery(path, params), { credentials: 'same-origin' });
    if (!response.ok) {
        throw new Error(await readErrorMessage(response));
    }
    await downloadResponseAsFile(response, 'Endurance_Sales_Report.xlsx');
}
